import axiosInstance from "../lib/axios";
import {
  LoginCredentials,
  LoginResponse,
  UpdateProfilePayload,
  ChangePasswordPayload,
  ForgotPasswordPayload,
  VerifyOtpPayload,
  VerifyOtpResponse,
  ResetPasswordPayload,
} from "../types/auth";

export const authService = {
  login: async (credentials: LoginCredentials): Promise<LoginResponse> => {
    const response = await axiosInstance.post(
      "/manufacturer/auth/login",
      credentials,
    );
    return response.data;
  },

  logout: async () => {
    const response = await axiosInstance.post("/manufacturer/auth/logout");
    return response.data;
  },

  forgotPassword: async (payload: ForgotPasswordPayload) => {
    const response = await axiosInstance.post(
      "/manufacturer/auth/forgot-password",
      payload,
    );
    return response.data;
  },

  verifyOtp: async (payload: VerifyOtpPayload): Promise<VerifyOtpResponse> => {
    const response = await axiosInstance.post(
      "/manufacturer/auth/verify-reset-otp",
      payload,
    );
    return response.data;
  },

  resetPassword: async (payload: ResetPasswordPayload) => {
    const response = await axiosInstance.post(
      "/manufacturer/auth/reset-password",
      payload,
    );
    return response.data;
  },

  getProfile: async () => {
    const response = await axiosInstance.get("/manufacturer/profile");
    return response.data;
  },

  updateProfile: async (payload: UpdateProfilePayload) => {
    const response = await axiosInstance.put(
      "/manufacturer/profile",
      payload,
    );
    return response.data;
  },

  changePassword: async (payload: ChangePasswordPayload) => {
    const response = await axiosInstance.put(
      "/manufacturer/profile/password",
      payload,
    );
    return response.data;
  },
};
